import { axios } from '@/utils/request'

export function queryWhiteList (parameter = {}) {
  return axios({
    url: '/white/queryWhiteList',
    method: 'post',
    data: parameter
  })
}


export function assignTasks (parameter = {}) {
  return axios({
    url: '/white/assignTasks',
    method: 'post',
    data: parameter
  })
}